import React, { memo } from 'react';
import classnames from 'classnames';
import Typography from '@cdo/apps/componentLibrary/typography';
import moduleStyles from './radioButton.module.scss';
import { componentSizeToBodyTextSizeMap } from '@cdo/apps/componentLibrary/common/constants';
var RadioButton = function (_a) {
    var label = _a.label, checked = _a.checked, onChange = _a.onChange, name = _a.name, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'm' : _c;
    var bodyTextSize = componentSizeToBodyTextSizeMap[size];
    return (React.createElement("label", { className: classnames(moduleStyles.radioButton, moduleStyles["radioButton-".concat(size)]) },
        React.createElement("input", { type: "radio", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange }),
        React.createElement("i", { className: moduleStyles.radioIcon }),
        label && (React.createElement(Typography, { semanticTag: "span", className: moduleStyles.radioButtonLabel, visualAppearance: bodyTextSize }, label))));
};
/**
 * ### Production-ready Checklist:
 * * (✔) implementation of component approved by design team;
 * * (✔) has storybook, covered with stories and documentation;
 * * (✔) has tests: test every prop, every state and every interaction that's js related;
 * * (see apps/test/unit/componentLibrary/RadioButtonTest.jsx, apps/test/unit/componentLibrary/RadioButtonsGroupTest.jsx)
 * * (?) passes accessibility checks;
 *
 * ###  Status: ```Ready for dev```
 *
 * Design System: Radio Button Component.
 * Can be used to render a single Radio Button or as a part of bigger/more complex components (e.g. Radio Button Group).
 */
export default memo(RadioButton);
